export interface ZohoCustomerSettings {
  userId: number;
  zohoContactId?: string | null;
  zohoSyncEnabled: boolean;
  paymentTermsDays: 30 | 45 | 60;
  zohoSyncWarning?: string | null;
  previousZohoContactIds?: string[];
}

export interface ZohoCustomerSettingsUpdate {
  zohoSyncEnabled: boolean;
  paymentTermsDays: 30 | 45 | 60;
}

export function refreshZohoCustomerMapping(edited: ZohoCustomerSettings, backend: ZohoCustomerSettings): ZohoCustomerSettings {
  return {
    ...(edited || backend),
    zohoContactId: backend.zohoContactId,
    previousZohoContactIds: backend.previousZohoContactIds || [],
  };
}
